import React, { Component } from 'react';
import GetEditFormaPago from './getEditFormaPago';
import GetEditDatosCliente from './getEditDatosCliente';
import GetListUbications from './getListUbications';
import GetNewUbication from './getNewUbication';

const MAX_LENGTH_referencia = 100;
const MAX_LENGTH_observacion = 100;

class getCMenu extends Component {
  constructor(){
    super();
    this.state = {
      dir_sub_modulo_modal:'',
      showComprobante:false,
    }
  }
  /*id_forma_pago : 0,
  forma_pago :"Seleccionar Pago",
  razon_social :"CONSUMIDOR FINAL",
  ruc:"9999999999999",
  telefono:"S/N",
  direccion:"S/N",
  email:"S/N",
  id_datos_facturacion:0,
  alias:"Seleccionar Alias",
  ubicacion:'Seleccionar Ubicación',
  nombre:'',
  id_ubicacion:0,
  lat:0,lon:0*/
  toggleComprobante = () => {
    this.setState(s => ({ showComprobante: !s.showComprobante }));
  };

  get_buscar_cliente =()=>{
    this.props.editarCliente()
  }
  get_view_ubication =()=>{
    const id_cliente = this.props.id_cliente
    if(Number(id_cliente)>0){
      this.setState({
        dir_sub_modulo_modal:'editubicacion'
      },()=>{
        this.props.get_encerar_direccion()
      })
    }
  }
  get_edit_formapago=()=>{
    const id_cliente = this.props.id_cliente
    if(Number(id_cliente)>0){
      this.setState({
        dir_sub_modulo_modal:'editformapago'
      })
    }
  }
  get_edit_alias=()=>{
    const id_cliente = this.props.id_cliente
    if(Number(id_cliente)>0){
      this.setState({
        dir_sub_modulo_modal:'editdatosclientes'
      })
    }
  }
  inputChangedHandler2 = (event)=>{
    this.props.inputChangedHandler2(event.target.value)
  }
  inputChangedHandler3 = (event)=>{
    this.props.inputChangedHandler3(event.target.value)
  }
  inputChangedHandler4 = (event) => {
   const isChecked = event.target.checked;
    this.props.inputChangedHandler4(isChecked);

    
  };
  inputChangedHandler5 = (event) => {
   const isChecked = event.target.checked;
    this.props.inputChangedHandler5(isChecked);

    
  };
  get_go_to=(opcion)=>{
    this.setState({
      dir_sub_modulo_modal:opcion
    })
  }
  get_go_to_sub =()=>{
    this.setState({
      dir_sub_modulo_modal:''
    },()=>{
      this.props.get_List_Cliente()
    })
  }
  get_coordenadas=(lat,lon,ubicacion,id_ubicacion,referencia)=>{
    this.setState({
      dir_sub_modulo_modal:""
    },()=>{
      this.props.get_coordenadas(lat,lon,ubicacion,id_ubicacion,referencia)
    })
  }

  render (){
    const dir_sub_modulo_modal = this.state.dir_sub_modulo_modal
    let sub_modulo_modal
    if(dir_sub_modulo_modal==='editformapago'){
        sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetEditFormaPago  token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  get_go_to_sub={this.get_go_to_sub} />
                               </div>
    }
    if(dir_sub_modulo_modal==='editdatosclientes'){
        sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetEditDatosCliente  token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  get_go_to_sub={this.get_go_to_sub} />
                               </div>
    }
    if(dir_sub_modulo_modal==='editubicacion'){
        sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetListUbications database={this.props.database} id_ubicacion={this.state.id_ubicacion}  get_coordenadas={this.get_coordenadas} get_go_to={this.get_go_to}  token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  get_go_to_sub={this.get_go_to_sub} />
                               </div>
    }
    if(dir_sub_modulo_modal==='newubicacion'){
      sub_modulo_modal = <div id="loader_msg" className="loader_msg loader_msg-default is-active" data-text="">
                        <GetNewUbication database={this.props.database}  get_coordenadas={this.get_coordenadas} token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url} get_go_to={this.get_go_to}/>
                        </div>
    }

    return (
      <React.Fragment>
        <div className="cssversion_menu cssversion_colorwhite" style={{"color":"black"}}>
          <div
              style={{
                  maxHeight: "calc(100vh - 120px)",   // 🔥 Ajusta automáticamente según pantalla
                  overflowY: "auto",                  // 🔥 Muestra scroll solo si es necesario
                  paddingRight: "5px"
              }}
          >
          <div className="cssversion_pxw250" style={{"display":"flex"}}>
            <div className="cssversion_pw100">
              <span className="span-global-title-producto">DATOS DEL CLIENTE</span>
            </div>
          </div>
            <div className="cssversion_pxw250" onClick={ () => this.get_buscar_cliente()} style={{"display":"flex"}}>
              <div className="cssversion_pw15">
                <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ."  src={ require('../image/4609047631582004492-128.png') }  />
              </div>
              <div className="cssversion_pw85">
                <span className="span-global-title-producto">Seleccionar Cliente</span>
              </div>
            </div>
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw15">
                Cl:
              </div>
              <div className="cssversion_pw85">
                <span className="span-global-title-producto">{this.props.nombre}</span>
              </div>
            </div>
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw100">
                <span className="span-global-title-producto">DIRECCIÓN DE ENTREGA</span>
              </div>
            </div>
            <div className="cssversion_pxw250" onClick={ () => this.get_view_ubication()}style={{"display":"flex"}}>
              <div className="cssversion_pw15">
                <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ."  src={ require('../image/4609047631582004492-128.png') }  />
              </div>
              <div className="cssversion_pw85">
                <span className="span-global-title-producto">{this.props.ubicacion}</span>
              </div>
            </div>
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw100">
                  <input  value={this.props.referencia_entrega} onChange={(event)=>this.inputChangedHandler2(event)} className="input-global cssversion_pw90 red-input" placeholder="Referencia de Entrega" />
                  <div style={{ fontSize: "12px", color: this.props.referencia_entrega.length === MAX_LENGTH_referencia ? "red" : "#555", textAlign: "right" }}>
                    {this.props.referencia_entrega.length}/{MAX_LENGTH_referencia}
                  </div>
              </div>
            </div>
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw100">
                <span className="span-global-title-producto">FORMA DE PAGO</span>
              </div>
            </div>
            <div className="cssversion_pxw250" onClick={ () => this.get_edit_formapago()} style={{"display":"flex"}}>
              <div className="cssversion_pw15">
                <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ."  src={ require('../image/4609047631582004492-128.png') }  />
              </div>
              <div className="cssversion_pw85">
                <span className="span-global-title-producto">{this.props.forma_pago}
                </span>
                
              </div>
            </div>
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              {(this.props.forma_pago==='EFECTIVO')?
              <React.Fragment>{this.getbilletes(this.props.total_final)}</React.Fragment>
              :null}
            </div>
            {/* CABECERA: título clickeable para expandir/cerrar */}
              <div
                className="cssversion_pxw250"
                style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={this.toggleComprobante}
                role="button"
                aria-expanded={this.state.showComprobante}
                aria-controls="panel-comprobante"
              >
                <div className="cssversion_pw100">
                  <span className="span-global-title-producto">DATOS DEL COMPROBANTE</span>
                </div>
                {/* Indicador (triangulito) */}
                <span
                  style={{
                    marginLeft: "auto",
                    transition: "transform .2s ease",
                    transform: this.state.showComprobante ? "rotate(90deg)" : "rotate(0deg)"
                  }}
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </span>
              </div>

              {/* CONTENIDO: se muestra/oculta con animación */}
              <div
                id="panel-comprobante"
                style={{
                  overflow: "hidden",
                  transition: "max-height .25s ease",
                  maxHeight: this.state.showComprobante ? 1000 : 0 // ajusta si necesitas
                }}
              >
                <div className="cssversion_pxw250" onClick={() => this.get_edit_alias()} style={{ display: "flex" }}>
                  <div className="cssversion_pw15">
                    <img
                      style={{ width: "20px", height: "20px" }}
                      className="icon-global"
                      alt="Cargando Imagen . . ."
                      src={require("../image/4609047631582004492-128.png")}
                    />
                  </div>
                  <div className="cssversion_pw85">
                    <span className="span-global-title-producto">{this.props.alias}</span>
                  </div>
                </div>

                <div className="cssversion_pxw250" style={{ display: "flex" }}>
                  <div className="cssversion_pw15">
                    <img
                      style={{ width: "20px", height: "20px" }}
                      className="icon-global"
                      alt="Cargando Imagen . . ."
                      src={require("../image/1388560951582004484-128.png")}
                    />
                  </div>
                  <div className="cssversion_pw85">
                    <span className="span-global-title-producto">{this.props.razon_social}</span>
                  </div>
                </div>

                <div className="cssversion_pxw250" style={{ display: "flex" }}>
                  <div className="cssversion_pw15">
                    <img
                      style={{ width: "20px", height: "20px" }}
                      className="icon-global"
                      alt="Cargando Imagen . . ."
                      src={require("../image/1388560951582004484-128.png")}
                    />
                  </div>
                  <div className="cssversion_pw85">
                    <span className="span-global-title-producto">{this.props.ruc}</span>
                  </div>
                </div>

                <div className="cssversion_pxw250" style={{ display: "flex" }}>
                  <div className="cssversion_pw15">
                    <img
                      style={{ width: "20px", height: "20px" }}
                      className="icon-global"
                      alt="Cargando Imagen . . ."
                      src={require("../image/9180212681582004495-128.png")}
                    />
                  </div>
                  <div className="cssversion_pw85">
                    <span className="span-global-title-producto">{this.props.telefono}</span>
                  </div>
                </div>

                <div className="cssversion_pxw250" style={{ display: "flex" }}>
                  <div className="cssversion_pw15">
                    <img
                      style={{ width: "20px", height: "20px" }}
                      className="icon-global"
                      alt="Cargando Imagen . . ."
                      src={require("../image/9478791231582004484-128.png")}
                    />
                  </div>
                  <div className="cssversion_pw85">
                    <span className="span-global-title-producto">{this.props.direccion}</span>
                  </div>
                </div>

                <div className="cssversion_pxw250" style={{ display: "flex" }}>
                  <div className="cssversion_pw15">
                    <img
                      style={{ width: "20px", height: "20px" }}
                      className="icon-global"
                      alt="Cargando Imagen . . ."
                      src={require("../image/16467180181582004498-128.png")}
                    />
                  </div>
                  <div className="cssversion_pw85">
                    <span className="span-global-title-producto">{this.props.email}</span>
                  </div>
                </div>
              </div>
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw100">
                <span className="span-global-title-producto">OBSERVACIÓN</span>
              </div>
            </div>
             <div className="cssversion_pxw250" style={{"display":"flex"}}>
              
              <div>
                <textarea
                  value={this.props.observacion}
                  onChange={(event) => this.inputChangedHandler3(event)}
                  className="input-global cssversion_pw90 red-input"
                  placeholder="Observaciones del pedido..."
                  style={{ width: "100%",  resize: "none" }}
                />
                <div style={{ fontSize: "12px", color: this.props.observacion.length === MAX_LENGTH_observacion ? "red" : "#555", textAlign: "right" }}>
                  {this.props.observacion.length}/{MAX_LENGTH_observacion}
                </div>
              </div>
             
             </div>
              <div className="cssversion_pxw250" style={{"display":"flex"}}>
                <div className="cssversion_pw100">
                  <span className="span-global-title-producto">PEDIDO PARA RETIRAR</span>
                </div>
              </div>
              <div className="cssversion_pxw250" style={{"display":"flex"}}>
                  <label className="EstiloToggleV2">
                  <input
                    type="checkbox"
                    checked={this.props.sw_llevar}
                    onChange={(event) => this.inputChangedHandler4(event)}
                  />
                  <span className="slider"></span>
                </label>
                <span className="estado-texto">
                  {this.props.sw_llevar ? 'SÍ' : 'NO'}
                </span>
              </div>
              <div className="cssversion_pxw250" style={{"display":"flex"}}>
                <div className="cssversion_pw100">
                  <span className="span-global-title-producto">CON CUBIERTOS</span>
                </div>
              </div>
              <div className="cssversion_pxw250" style={{"display":"flex"}}>
                  <label className="EstiloToggleV2">
                  <input
                    type="checkbox"
                    checked={this.props.sw_cubiertos}
                    onChange={(event) => this.inputChangedHandler5(event)}
                  />
                  <span className="slider"></span>
                </label>
                <span className="estado-texto">
                  {this.props.sw_cubiertos ? 'SÍ' : 'NO'}
                </span>
              </div>


            {(Number(this.props.total_kilometros)>0)?
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw70">
                Total Kilómetros
              </div>
              <div className="cssversion_pw30">
                 {Number(this.props.total_kilometros).toFixed(2)} Km
              </div>
            </div>
            :null}
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw70">
                Subtotal Productos
              </div>
              <div className="cssversion_pw30">
                 ${Number(this.props.total_precio).toFixed(2)}
              </div>
            </div>
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw70">
                Transporte
              </div>
              <div className="cssversion_pw30">
                 ${(this.props.sw_llevar)?'0.00':Number(this.props.costo_delivery).toFixed(2)}
              </div>
            </div>
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw70">
                Descuento
              </div>
              <div className="cssversion_pw30">
                ${Number(this.props.descuento).toFixed(2)}
              </div>
            </div>
            <div className="cssversion_pxw250" style={{"display":"flex"}}>
              <div className="cssversion_pw70">
                Total Comprobante
              </div>
              <div className="cssversion_pw30">
                 ${Number(this.props.total_final).toFixed(2)}
              </div>
            </div>
            {sub_modulo_modal}
        </div></div>
      </React.Fragment>
    )
  }

  getbilletes = (valor_efectivo)=>{
    if(valor_efectivo===0)return;
    const valor = Number(valor_efectivo).toFixed(2)
    
    let billete1 = Math.floor(valor)+1
    let valor_integer = Math.floor(valor)
    do {
      valor_integer = valor_integer + 1
      var resto = valor_integer % 5;
      if ( resto === 0 ){
        break;
      }
    }while (true);
    let billete5 = valor_integer
    valor_integer = Math.floor(valor)
    do {
      valor_integer = valor_integer + 1
      var resto1 = valor_integer % 10;
      if ( resto1 === 0 ){
        break;
      }
    }while (true);
    let billete10 = valor_integer
    valor_integer = Math.floor(valor)
    do {
      valor_integer = valor_integer + 1
      var resto2 = valor_integer % 20;
      if ( resto2 === 0 ){
        break;
      }
    }while (true);
    let billete20 = valor_integer
    if(valor===billete1){
      billete1 = 0
    }
    if(valor===billete5){
      billete5 = 0
    }
    if(valor===billete10){
      billete10 = 0
    }
    if(valor===billete20){
      billete20 = 0
    }

    if(billete1===billete5){
      billete5 = 0
    }
    if(billete1===billete10){
      billete10 = 0
    }
    if(billete1===billete20){
      billete20 = 0
    }

    if(billete5===billete10){
      billete10 = 0
    }
    if(billete5===billete20){
      billete20 = 0
    }

    if(billete10===billete20){
      billete20 = 0
    }
    const valor_pago_efectivo = this.props.valor_pago_efectivo
    //alert(valor_pago_efectivo)
    return(
      <React.Fragment>
         
          {(Number(valor)>0)?
            <div className="cssversion_pxh50 cssversion_pxw50 cssversion_contentCenter" style={{"display":"flex"}}>
              <div onClick={ () => this.props.getDataVuelto(valor)} className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(valor))?"#229954":"#82E0AA","borderRadius": "15px"}}>
                <span className="span-global" style={{"color":"white","fontSize":"10pt","fontFamily":"Arial"}} >{valor}$</span>
              </div>
            </div>
            :''}
          {(Number(billete1)>0)?
            <div className="cssversion_pxh50 cssversion_pxw50 cssversion_contentCenter" style={{"display":"flex"}}>
              <div onClick={ () => this.props.getDataVuelto(billete1)}className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(billete1))?"#229954":"#82E0AA","borderRadius": "15px"}}>
                <span className="span-global" style={{"color":"white","fontSize":"10pt","fontFamily":"Arial"}}>{billete1}$</span>
              </div>
            </div>
            :''}
          {(Number(billete5)>0)?
            <div className="cssversion_pxh50 cssversion_pxw50 cssversion_contentCenter" style={{"display":"flex"}}>
              <div onClick={ () => this.props.getDataVuelto(billete5)}className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(billete5))?"#229954":"#82E0AA","borderRadius": "15px"}}>
                <span className="span-global" style={{"color":"white","fontSize":"10pt","fontFamily":"Arial"}} >{billete5}$</span>
              </div>
            </div>
            :''}
          {(Number(billete10)>0)?
            <div className="cssversion_pxh50 cssversion_pxw50 cssversion_contentCenter" style={{"display":"flex"}}>
              <div onClick={ () => this.props.getDataVuelto(billete10)}className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(billete10))?"#229954":"#82E0AA","borderRadius": "15px"}}>
                <span className="span-global" style={{"color":"white","fontSize":"10pt","fontFamily":"Arial"}} >{billete10}$</span>
              </div>
            </div>
            :''}
          {(Number(billete20)>0)?
          <div className="cssversion_pxh50 cssversion_pxw50 cssversion_contentCenter" style={{"display":"flex"}}>
            <div onClick={ () => this.props.getDataVuelto(billete20)}className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(billete20))?"#229954":"#82E0AA","borderRadius": "15px"}}>
            <span className="span-global" style={{"color":"white","fontSize":"10pt","fontFamily":"Arial"}}>{billete20}$</span>
            </div>
          </div>
          :''}
         
      </React.Fragment>
    )
  }
}
export default getCMenu;
